// src/interactions/insights/insights.js

import { getDatabase, ref, set, push, update, onValue } from 'firebase/database';
import { getPresentationIdByPin } from '../../firebaseFunctions'; // Importação da função
import { database } from '../../firebaseConfig'; // Importação do objeto database

export const createInsightsInteraction = async (userId, presentationId, interaction) => {
  const db = getDatabase();
  const interactionRef = ref(db, `presentations/${userId}/${presentationId}/interactions/${interaction.id}`);
  await set(interactionRef, interaction);
};

export const createInsightsObject = (interaction) => {
  return {
    id: interaction.id,
    type: "insights",
    title: interaction.title || "Insights",
    responses: {},
    createdAt: Date.now()
  };
};

export const updateInsightsInteraction = async (userId, presentationId, interactionId, interaction) => {
  const db = getDatabase();
  const interactionRef = ref(db, `presentations/${userId}/${presentationId}/interactions/${interactionId}`);
  await update(interactionRef, interaction);
};

export const removeInsightsInteraction = async (userId, presentationId, interactionId) => {
  const db = getDatabase();
  const interactionRef = ref(db, `presentations/${userId}/${presentationId}/interactions/${interactionId}`);
  await set(interactionRef, null);
};

export const submitInsightResponse = async (pin, interactionId, response) => {
  try {
    const { presentationId, userId } = await getPresentationIdByPin(pin);
    if (!presentationId) throw new Error('Presentation not found for the given PIN');

    const responseRef = ref(database, `presentations/${userId}/${presentationId}/interactions/${interactionId}/responses`);
    const newResponseRef = push(responseRef);
    await update(newResponseRef, { text: response });
  } catch (error) {
    console.error('Error submitting response:', error);
  }
};

export const listenToInsightResponses = async (pin, interactionId, callback) => {
  const { presentationId, userId } = await getPresentationIdByPin(pin);
  if (!presentationId) throw new Error('Presentation not found for the given PIN');

  const responseRef = ref(database, `presentations/${userId}/${presentationId}/interactions/${interactionId}/responses`);
  return onValue(responseRef, (snapshot) => {
    const data = snapshot.val();
    callback(data || {});
  });
};
